import React from 'react'
import { NavLink } from 'react-router-dom'

const MainNav = () => (
  <div className="navbar-nav mr-auto">
    <NavLink
      to="/"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Home
    </NavLink>
    <NavLink
      to="/create-game"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Create Game
    </NavLink>
    <NavLink
      to="/create-lesson"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Lesson Overview
    </NavLink>
    <NavLink
      to="/deploy-lesson"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Deploy Lesson
    </NavLink>
  </div>
)

export default MainNav
